module.exports = __webpack_public_path__ + "img/community-norm-me_ar.d3052c9b.png";